import { Box, Typography, Button, Container, useTheme, useMediaQuery } from '@mui/material';
import { Home as HomeIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/img/logo.png';

const NotFound = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const navigate = useNavigate();

    return (
        <Container maxWidth="md">
            <Box
                sx={{
                    minHeight: 'calc(100vh - 64px)', // Account for header height
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                    py: 4
                }}
            >
                <img
                    src={logo}
                    alt="Total Turf Experience"
                    style={{
                        width: isMobile ? '150px' : '200px',
                        marginBottom: '2rem',
                        opacity: 0.9
                    }}
                />
                
                <Typography
                    variant={isMobile ? 'h2' : 'h1'}
                    component="h1"
                    color="primary"
                    sx={{
                        fontWeight: 'bold',
                        mb: 2,
                        fontSize: isMobile ? '4rem' : '6rem',
                        opacity: 0.9
                    }}
                >
                    404
                </Typography>

                <Typography
                    variant={isMobile ? 'h5' : 'h4'}
                    component="h2"
                    color="text.primary"
                    gutterBottom
                    sx={{ mb: 3, fontWeight: 500 }}
                >
                    Page Not Found
                </Typography>

                <Typography
                    variant="body1"
                    color="text.secondary"
                    sx={{ mb: 4, maxWidth: '600px' }}
                >
                    The page you're looking for doesn't exist or has been moved. 
                    Please check the URL or return to the home page.
                </Typography>

                <Button
                    variant="contained"
                    size="large"
                    startIcon={<HomeIcon />}
                    onClick={() => navigate('/')}
                    sx={{
                        py: 1.5,
                        px: 4,
                        borderRadius: 2,
                        textTransform: 'none',
                        fontSize: '1.1rem'
                    }}
                >
                    Return Home
                </Button>
            </Box>
        </Container>
    );
};

export default NotFound; 